export default defineNuxtPlugin(() => {
  const { $i18n } = useNuxtApp();
  const config = useRuntimeConfig();

  // TODO: фейковая ошибка типов
  // @ts-expect-error: TS2322: Type 'string' is not assignable to type '"ru" | undefined'.
  $i18n.setLocale(config.public.locale);
});
